import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import CardHeader from '@r1-frontend/ui-react/organisms/Card/CardBricks/CardHeader';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

interface IStyledHeaderProps {
    group: string,
    title: string,
    description: string,
}

const StyledHeader = ({
    group,
    title,
    description,
}: IStyledHeaderProps): JSX.Element => {
    return (
        <ListContainer $size={4} $direction={'column'}>
            <Paragraph5 $color={COLORS.TextHint}>{group}</Paragraph5>
            <CardHeader
                title={title}
                description={description}
            />
        </ListContainer>
    );
};

export default StyledHeader;
